import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/app/(main)/error.tsx");
